import { Card, CardTitle, Separator } from '@repo/shadcn';

import { SupplierForm } from '../create.supplier/form.component';
import { useEditSupplier } from './edit-supplier.hook';

export const EditSupplierModal = () => {
    const { data, isLoading, isError, onSubmit, isUpdating } =
        useEditSupplier();

    const renderContent = () => {
        if (isLoading) {
            return <div>Loading...</div>;
        }
        if (isError) {
            return <div>Something went wrong</div>;
        }
        if (data) {
            const initialValues = {
                name: data?.data?.name,
                email: data?.data?.email ?? '',
                phone_number: data?.data?.phone_number ?? '',
                address: data?.data?.address ?? '',
            };

            return (
                <SupplierForm
                    isEditMode={true}
                    onSubmit={onSubmit}
                    isLoading={isLoading || isUpdating}
                    initialValues={initialValues}
                />
            );
        }
    };

    return (
        <Card className="border-none shadow-none">
            <CardTitle className="mb-2 text-[18px]"> Edit Supplier</CardTitle>
            <Separator />
            {renderContent()}
        </Card>
    );
};
